var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 h-100 d-flex align-items-center justify-content-center"},[_c('b-spinner',{staticStyle:{"width":"4rem","height":"4rem"},attrs:{"variant":"info","label":"Large Spinner"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }